import { Button, Form, Input, Table } from "antd";
import { useEffect, useState } from "react";
import PageHeader from "../../components/shared/PageHeader";
import { RiFilterOffLine } from "react-icons/ri";
import { AiOutlineFilePdf } from "react-icons/ai";
import { BsCalendar2Check, BsEye } from "react-icons/bs";
import StatementPannel from "./components/StatementPanel";
import DetailsPannel from "./components/DetailsPanel";
import searchAllCompanies from "../../services/searchAllCompanies";
import searchByAccount from "../../services/searchByAccount";
import fetchAllCustomers from "../../services/fetchAllCustomers";
import { FiEdit } from "react-icons/fi";
import { ExportToExcel } from "../../utils/XLSXExport";
import { BiExport } from "react-icons/bi";
import SegmentWidget from "./components/SegmentWidget";
import UpdatePanel from "./components/UpdatePanel";
import BookingsPanel from "./components/BookingsPanel";
const { startCase } = require("lodash");

const { Search } = Input;

export default function AllCustomers() {
  const [showStatement, setShowStatement] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [showBookings, setShowBookings] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [selected, setSelected] = useState({});
  const [customers, setCustomers] = useState([]);
  const [startDate, setStateDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [searchKey, setSearchKey] = useState(null);
  const [searchAcc, setSearchAcc] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    limit: 10,
  });

  const [form] = Form.useForm();

  const handleFetchCustomers = async ({ pagination }: any) => {
    setLoading(true);
    const data = await fetchAllCustomers(pagination);
    setLoading(false);
    setPagination({ total: data?.count, ...pagination });
    setCustomers(data?.results);
  };

  const handleReFetchCustomers = async ({ pagination }: any) => {
    const data = await fetchAllCustomers(pagination);
    setPagination({ total: data?.count, ...pagination });
    setCustomers(data?.results);
  };

  const handleSearchCustomer = async ({ value, pagination }: any) => {
    setLoading(true);
    const data = await searchAllCompanies(value, pagination);
    setLoading(false);
    setPagination({ total: data?.count, ...pagination });
    setCustomers(data?.results);
  };

  const handleSearchAccount = async ({ value, pagination }: any) => {
    setLoading(true);
    const data = await searchByAccount(value, pagination);
    setLoading(false);
    setPagination({ total: data?.count, ...pagination });
    setCustomers(data?.results);
  };

  const refetch = async () => {
    await handleReFetchCustomers({ pagination });
  };

  useEffect(() => {
    handleFetchCustomers({ pagination });
  }, []);

  const clearDate = () => {
    form.resetFields();
    setStateDate(new Date());
    setEndDate(new Date());
    handleFetchCustomers({
      pagination: { current: 1, pageSize: 10, limit: 10 },
    });
    setSearchAcc(null);
    setSearchKey(null);
  };

  const handleTableChange = (pagination: any) => {
    if (searchKey !== null) {
      let value = searchKey;
      handleSearchCustomer({ value, pagination });
      return;
    }
    if (searchAcc !== null) {
      let value = searchAcc;
      handleSearchAccount({ value, pagination });
      return;
    }
    handleFetchCustomers({
      pagination,
    });
  };

  const columns = [
    {
      title: "S/N",
      width: 50,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Name",
      width: 110,
      render: (record: any) => {
        const name = record?.name;
        return (
          <span className="text-gray-700">{startCase(name.toLowerCase())}</span>
        );
      },
    },
    {
      title: "Account",
      width: 70,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.account === null ? "-" : record?.account}
        </span>
      ),
    },
    {
      title: "Segment",
      width: 100,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.segment?.name === null ? "-" : record?.segment?.name}
        </span>
      ),
    },
    {
      title: "Email",
      width: 100,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.email === null ? "-" : record?.email}
        </span>
      ),
    },
    {
      title: "Telephone",
      width: 100,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.phone === null ? "-" : record?.phone}
        </span>
      ),
    },
    {
      title: "Mobile 1",
      width: 80,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.mobile === null ? "-" : record?.mobile}
        </span>
      ),
    },
    {
      title: "Mobile 2",
      width: 80,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.mobile2 === null ? "-" : record?.mobile2}
        </span>
      ),
    },

    {
      title: "Last Activity",
      width: 100,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.unused === 0
            ? "This Month"
            : `${record?.unused} Month(s) ago`}
        </span>
      ),
    },
    {
      title: "Edit",
      width: 60,
      render: (record: any) => (
        <div className="flex">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setUpdateModal(true);
            }}
            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-yellow-100 hover:bg-yellow-200 cursor-pointer"
          >
            <FiEdit /> <span className="ml-1">Edit</span>
          </button>
        </div>
      ),
    },
    {
      title: "Bookings",
      width: 80,
      render: (record: any) => (
        <button
          onClick={() => {
            setSelected({
              ...record,
            });
            setShowBookings(true);
          }}
          className="flex justify-center items-center text-gray-700 border rounded-md p-2 mx-1 bg-green-100 hover:bg-green-200 cursor-pointer"
        >
          <BsCalendar2Check /> <span className="ml-1">Bookings</span>
        </button>
      ),
    },
    {
      title: "Statement",
      width: 80,
      render: (record: any) => (
        <button
          onClick={() => {
            setSelected({
              ...record,
            });
            setShowStatement(true);
          }}
          className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-blue-100 hover:bg-blue-200 cursor-pointer"
        >
          <AiOutlineFilePdf /> <span className="ml-1">Statement</span>
        </button>
      ),
    },
    {
      title: "Details",
      width: 100,
      render: (record: any) => (
        <button
          onClick={() => {
            setSelected({
              ...record,
            });
            setShowDetails(true);
          }}
          className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-pointer"
        >
          <BsEye /> <span className="ml-1">Details</span>
        </button>
      ),
    },
  ];

  return (
    <div className=" bg-gray-100 overflow-x-hidden">
      <div className="flex justify-between items-center border-b border-gray-300 py-2 mx-4">
        <div className="flex">
          <Form layout="inline" form={form}>
            <Form.Item name="name">
              <Search
                placeholder="Search by name"
                allowClear
                onChange={(e: any) => {
                  setSearchKey(e.target.value);
                }}
                onSearch={(value: any) =>
                  handleSearchCustomer({
                    value,
                    pagination: {
                      current: 1,
                      pageSize: 10,
                      limit: 10,
                    },
                  })
                }
              />
            </Form.Item>
            <Form.Item name="account">
              <Search
                placeholder="Search by account"
                allowClear
                onChange={(value: any) => setSearchAcc(value)}
                onSearch={(value: any) =>
                  handleSearchAccount({
                    value,
                    pagination: {
                      current: 1,
                      pageSize: 10,
                      limit: 10,
                    },
                  })
                }
              />
            </Form.Item>
            <Button className="" onClick={() => clearDate()}>
              <RiFilterOffLine color="#6b7280" />
            </Button>
          </Form>
        </div>
      </div>

      {/* <WidgetWrapper /> */}
      <div className="m-4">
        <div className="grid grid-cols-12 gap-2 mb-4">
          <SegmentWidget
            name={"Government"}
            id={"624c2ff91ba811cdc681915a"}
            refetch={refetch}
          />
          <SegmentWidget
            name={"Corporate"}
            id={"624c2f824e084efd664e644d"}
            refetch={refetch}
          />
          <SegmentWidget
            name={"Non Profit"}
            id={"624c302e1ba811cdc6819162"}
            refetch={refetch}
          />
          <SegmentWidget
            name={"Mining"}
            id={"624c30211ba811cdc6819160"}
            refetch={refetch}
          />
          <SegmentWidget
            name={"Individual"}
            id={"624c300e1ba811cdc681915d"}
            refetch={refetch}
          />
          <SegmentWidget
            name={"Staff"}
            id={"626a612938fb9bbe16c670b1"}
            refetch={refetch}
          />
        </div>
      </div>

      <div className="flex flex-col border border-gray-300 mx-4 rounded-lg mt-2 bg-white">
        <div className="">
          <PageHeader
            title="Customers"
            subtitle="List of all customers"
            tag="List"
            actions={
              <>
                <button
                  color="#E50000"
                  className="flex justify-center items-center border p-1 hover:bg-green-100"
                >
                  <BiExport size={24} />
                  <span
                    className="ml-2"
                    onClick={() =>
                      ExportToExcel(
                        customers?.map((record: any, index: number) => {
                          return {
                            "S/N": index + 1,
                            Name: record?.name,
                            Account: record?.account ? record?.account : "-",
                            Segment: record?.segment?.name
                              ? record?.segment?.name
                              : "-",
                            Email: record?.email ? record?.email : "-",
                            Telephone: record?.phone ? record?.phone : "-",
                            Mobile: record?.mobile ? record?.mobile : "-",
                            "Last Activity":
                              record?.unused === 0
                                ? "This Month"
                                : `${record?.unused} Month(s) ago`,
                          };
                        }),
                        "Customers.xlsx"
                      )
                    }
                  >
                    Export To Excel
                  </span>
                </button>
              </>
            }
          />

          <div className="grid gap-x-0 grid-cols-12">
            <div className="col-span-12 sm:col-span-12 md:col-span-12">
              <Table
                size="middle"
                dataSource={isLoading ? [] : customers}
                columns={columns}
                pagination={pagination}
                scroll={{ y: 360, x: 0 }}
                rowKey="id"
                loading={isLoading}
                onChange={handleTableChange}
              />

              <StatementPannel
                isVisible={showStatement}
                setVisible={setShowStatement}
                selected={selected}
              />

              <DetailsPannel
                isVisible={showDetails}
                setVisible={setShowDetails}
                selected={selected}
              />

              <BookingsPanel
                isVisible={showBookings}
                setVisible={setShowBookings}
                selected={selected}
              />

              {/* <UpdateCustomer
                selected={selected}
                isVisible={updateModal}
                setVisible={setUpdateModal}
                refetch={refetch}
              /> */}

              <UpdatePanel
                selected={selected}
                isVisible={updateModal}
                setVisible={setUpdateModal}
                refetch={refetch}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
